import classNames from "classnames";
import { useMemo } from "react";
import { PlaceStatus } from "../../types/PlaceStatus";
import "./PlaceStatusAlert.scss";

interface PlaceStatusAlertProps {
  status: PlaceStatus | undefined;
}

export default function PlaceStatusAlert({ status }: PlaceStatusAlertProps) {
  const summaryText = useMemo(() => {
    switch (status) {
      case PlaceStatus.ACTIVE:
        return "This place is open for pool!";
      case PlaceStatus.CLOSED_TEMPORARILY:
        return "This place may be temporarily closed";
      case PlaceStatus.NO_LONGER_HAS_POOL:
        return "This place may no longer have pool tables";
      case PlaceStatus.OUT_OF_BUSINESS:
        return "This place may be closed";
      case PlaceStatus.PENDING:
        return "This place is pending review";
      case PlaceStatus.REJECTED:
        return "This place was rejected";
      case PlaceStatus.UNDER_REVIEW:
        return "This place is under review";
      case PlaceStatus.UNKNOWN:
      default:
        return "";
    }
  }, [status]);

  if (!status || status === PlaceStatus.ACTIVE) {
    return null;
  }

  const className = classNames("place-status-alert", status);
  return <div className={className}>{summaryText}</div>;
}
